<template>
  <div>
    <v-card>
      <div class="text-xs-right">
        <v-btn small flat fab @click="handleCancel" :loading="saveLoading">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12 sm6 class="form-control px-1">
            <div class="caption mb-1 mt-2">Username *</div>
            <input
              type="text"
              :placeholder="$t('Username')"
              v-model="user.userid"
              class="form-control"
              maxlength="255"
              :disabled="isEdit"
            />
          </v-flex>
          <v-flex xs12 sm6 class="form-control px-1">
            <template v-if="!isEdit">
              <div class="caption mb-1 mt-2">Password *</div>
              <input
                type="password"
                :placeholder="$t('Password')"
                v-model="user.password"
                class="form-control"
                maxlength="255"
                :disabled="isEdit"
              />
            </template>
          </v-flex>

          <v-flex xs12 class="pt-3">
            <div class="caption">Role</div>
            <v-layout wrap>
              <v-radio-group v-model="privilege.role" row>
                <v-radio color="primary" label="Super admin" value="superadmin"></v-radio>
                <v-radio color="primary" label="หัวหน้าศูนย์" value="supervisor"></v-radio>
                <v-radio color="primary" label="พนักงานอนุมัติ" value="approver"></v-radio>
              </v-radio-group>
            </v-layout>
          </v-flex>
          <v-flex
            v-if="privilege.role === 'supervisor' || privilege.role === 'approver'"
            xs12
            sm6
            class="form-control px-1"
            :class="{ 'has-error': errors.has('group') }"
          >
            <div class="caption mb-1">ศูนย์</div>
            <multiselect
              v-model="user.group"
              :options="branchOptions"
              track-by="branch_id"
              label="branch_name"
              name="group"
              :searchable="true"
              selectLabel
              selectedLabel
              v-validate="'required'"
              :openDirection="'above'"
              :max-height="250"
            ></multiselect>
            <p class="text-error" v-if="errors.has('group')">{{ errors.first('group') }}</p>
          </v-flex>
        </v-layout>
        <div class="text-xs-center mt-3">
          <v-btn outline color="grey" @click="handleCancel" :loading="saveLoading">{{
            $t('cancel')
          }}</v-btn>
          <v-btn color="primary" depressed @click="handleSubmit" :loading="saveLoading">{{
            $t('Save')
          }}</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import yasaleAcApi from '@/api/yasale-ac'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'

export default {
  props: ['value', 'branchList'],
  components: {
    Multiselect
  },
  data() {
    return {
      user: {
        userid: null,
        password: null,
        group: null
      },
      privilege: {
        role: ''
      },
      branchOptions: [],
      isEdit: false,
      saveLoading: false
    }
  },
  async mounted() {
    this.branchOptions = this.branchList

    if (this.value) {
      this.isEdit = true
      this.user.userid = this.value.adminid

      if (this.value.admingroupid) {
        const currentOption = this.branchOptions.find((item) => {
          if (item.branch_id === this.value.admingroupid) {
            return item
          }
        })
        this.user.group = currentOption
      }

      if (this.value.privilege) {
        this.privilege = JSON.parse(this.value.privilege)
      } else {
        this.privilege = {
          role: ''
        }
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    async handleSubmit() {
      const vm = this
      if (await vm.$validator.validate()) {
        let privilege = { ...this.privilege }
        let data = {
          pageid: vm.selectedBot.pageid,
          userid: vm.user.userid,
          // admingroupid: vm.user.group ? vm.user.group.branch_id : '',
          admingroupid:
            privilege.role == 'superadmin' ? null : vm.user.group ? vm.user.group.branch_id : '',

          privilege: JSON.stringify(privilege)
        }

        if (!vm.isEdit) {
          Object.assign(data, { password: vm.user.password })
        }

        vm.saveLoading = true
        try {
          let response = []
          if (!vm.isEdit) {
            response = await vm.createAdminUser(data)
          } else {
            response = await vm.updateAdminUser(data)
          }

          vm.saveLoading = false
          if (response && response.data.responsecode == 200) {
            await vm.$swal.fire({
              text: 'สำเร็จ',
              type: 'success'
            })
            await vm.clearForm()
            vm.$emit('success')
          } else {
            await vm.$swal.fire({
              text: response.data.reason,
              type: 'error'
            })
          }
        } catch (error) {
          vm.saveLoading = false
          console.error(error)
        }
      }
    },
    async createAdminUser(data) {
      return new Promise(async (resolve) => {
        const response = await yasaleAcApi.createAdminUser({ data: data })
        resolve(response)
      })
    },
    async updateAdminUser(data) {
      return new Promise(async (resolve) => {
        const response = await yasaleAcApi.updateAdminUser({ data: data })
        resolve(response)
      })
    },
    clearForm() {
      this.user = {
        userid: null,
        password: null,
        group: null
      }
      this.privilege.role = ''
    },
    handleCancel() {
      this.clearForm()
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/YasaleAc/AdminManageDialog.vue